import { render, staticRenderFns } from "./AppButtonAddCancelFailureTracking.vue?vue&type=template&id=2232c4a6&scoped=true&"
import script from "./AppButtonAddCancelFailureTracking.vue?vue&type=script&lang=ts&"
export * from "./AppButtonAddCancelFailureTracking.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonAddCancelFailureTracking.vue?vue&type=style&index=0&id=2232c4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232c4a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
